import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles.css";

const FormAddRegistration = () => {
  const [name, setName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone2, setPhone2] = useState("");
  const [phone3, setPhone3] = useState("");
  const [phone4, setPhone4] = useState("");
  const [msg, setMsg] = useState("");
  const [searchId, setSearchId] = useState("");
  const [searchedData, setSearchedData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [currentQr, setCurrentQr] = useState(null);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();


  const apiUrl = 'https://api.infosware-test.in';

  const validateForm = (data) => {
    let errors = {};
    let hasError = false;

    for (let key in data) {
      if (data[key].startsWith(" ")) {
        errors[key] = "Field cannot start with a space";
        hasError = true;
      }
      if ((key === "name" || key === "fatherName" || key === "district") && /\d/.test(data[key])) {
        errors[key] = `${key.replace(/([A-Z])/g, ' $1')} cannot contain numbers`;
        hasError = true;
      }
      if (key.startsWith("phone")) {
        if (!/^\d*$/.test(data[key])) {
          errors[key] = "Phone number cannot contain characters";
          hasError = true;
        }
        if (data[key].length !== 10 && data[key].length !== 0) {
          errors[key] = "Phone number must be exactly 10 digits";
          hasError = true;
        }
      }
    }

    if (data.phone1.length !== 10) {
      errors.phone1 = "Phone number 1 must be exactly 10 digits";
      hasError = true;
    }

    return { errors, hasError };
  };

  // Save registration form data
  const saveRegistration = async (e) => {
    e.preventDefault();

    const formData = {
      name,
      fatherName,
      address,
      district,
      phone1,
      phone2,
      phone3,
      phone4,
    };

    const { errors, hasError } = validateForm(formData);

    if (hasError) {
      setErrors(errors);
      return;
    }

    const data = {
      ...formData,
      qr_url: currentQr?.qr_url || "",
      status: "used",
    };

    try {
      const response = await axios.post(`${apiUrl}/api/registrations`, data);
      alert("Data saved successfully!");

      // Reset form fields
      setName("");
      setFatherName("");
      setAddress("");
      setDistrict("");
      setPhone1("");
      setPhone2("");
      setPhone3("");
      setPhone4("");
      setCurrentQr(null);
      setErrors({});

      navigate("/registrations");
      window.location.reload();
    } catch (error) {
      console.error("Error saving data:", error);
      // alert("Error saving data");
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  // Handle search by ID
  const handleSearch = async () => {
    if (!searchId) {
      alert("Please enter an ID to search.");
      return;
    }

    try {
      const id = searchId.split('/').pop();
      setSearchId(id);
      const response = await axios.get(`${apiUrl}/api/registrations/${id}`);
      const data = response.data;

      if (data.status === "used") {
        setSearchedData(data);
        setIsModalVisible(true);
        setIsFormVisible(false);
      } else {
        setCurrentQr(data);
        setIsFormVisible(true);
        setSearchedData(null);
        setIsModalVisible(false);
      }
    } catch (error) {
      console.error("Error fetching data by ID:", error);
      alert("ID not available");
    }
  };

  return (
    <div className="">
      <h1 className="title mt-5">New Registration</h1>
      <div className="field">
        <label className="label">Search by ID or QR URL:</label>
        <div className="control">
          <input
            type="text"
            className="input"
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            placeholder="Enter ID or QR URL"
          />
          <button onClick={handleSearch} className="button is-info mt-2">
            Search
          </button>
        </div>
      </div>

      {isModalVisible && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <div className="modal-header">
              <h2 className="modal-title">Registered Data</h2>
            </div>
            <div className="modal-body">
              <p>Name: {searchedData?.name || "N/A"}</p>
              {searchedData?.phone1 && <p>Family Head Number : {searchedData.phone1}</p>}
              {searchedData?.phone2 && <p>Phone 2: {searchedData.phone2}</p>}
              {searchedData?.phone3 && <p>Phone 3: {searchedData.phone3}</p>}
              {searchedData?.phone4 && <p>Phone 4: {searchedData.phone4}</p>}
            </div>
            <button className="close-button" onClick={() => setIsModalVisible(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* Form for new registration */}
      {isFormVisible && currentQr && (
        <div className="card is-shadowless">
          <div className="card-content">
            <div className="content">
              <div className="qr-id">
                <h2>QR Code URL: {currentQr.qr_url}</h2>
              </div>
              <form onSubmit={saveRegistration}>
                <p className="has-text-centered">{msg}</p>
                <div className="field">
                  <label className="label">Name</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Name"
                      required
                    />
                  </div>
                  {errors.name && <p className="help is-danger">{errors.name}</p>}
                </div>
                <div className="field">
                  <label className="label">Father's Name</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={fatherName}
                      onChange={(e) => setFatherName(e.target.value)}
                      placeholder="Father's Name"
                      required
                    />
                  </div>
                  {errors.fatherName && <p className="help is-danger">{errors.fatherName}</p>}
                </div>
                <div className="field">
                  <label className="label">Address</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Village/City"
                    />
                  </div>
                  {errors.address && <p className="help is-danger">{errors.address}</p>}
                </div>
                <div className="field">
                  <label className="label">District</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={district}
                      onChange={(e) => setDistrict(e.target.value)}
                      placeholder="District"
                    />
                  </div>
                  {errors.district && <p className="help is-danger">{errors.district}</p>}
                </div>
                <div className="field">
                  <label className="label">Family Head Number :</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={phone1}
                      onChange={(e) => setPhone1(e.target.value)}
                      placeholder="Phone Number 1"
                      required
                    />
                  </div>
                  {errors.phone1 && <p className="help is-danger">{errors.phone1}</p>}
                </div>
                <div className="field">
                  <label className="label">Phone Number 2</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={phone2}
                      onChange={(e) => setPhone2(e.target.value)}
                      placeholder="Phone Number 2"
                    />
                  </div>
                  {errors.phone2 && <p className="help is-danger">{errors.phone2}</p>}
                </div>
                <div className="field">
                  <label className="label">Phone Number 3</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={phone3}
                      onChange={(e) => setPhone3(e.target.value)}
                      placeholder="Phone Number 3"
                    />
                  </div>
                  {errors.phone3 && <p className="help is-danger">{errors.phone3}</p>}
                </div>
                <div className="field">
                  <label className="label">Phone Number 4</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={phone4}
                      onChange={(e) => setPhone4(e.target.value)}
                      placeholder="Phone Number 4"
                    />
                  </div>
                  {errors.phone4 && <p className="help is-danger">{errors.phone4}</p>}
                </div>
                <div className="field">
                  <div className="control">
                    <button type="submit" className="button is-success">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormAddRegistration;
